/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import SwitchField from "components/SwitchField";
import SelectField from "components/SelectField";
import { useEffect, useState } from "react";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import DatepickerField from "components/DatepickerField";
import Footer from "./components/footer";

export default function PaymentAccount01() {
  const { formId, formField } = form;

  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);

  const [list, setList] = React.useState([]);
  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };
  const handleSubmit = async (values, action) => {
    console.log({ values });
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Danh sách số hiệu tài khoản thanh toán
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <Footer
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}
const cityOption = [
  { value: "cityA", label: "Thành phố A" },
  { value: "cityB", label: "Thành phố B" },
  { value: "cityC", label: "Thành phố C" },
  { value: "cityD", label: "Thành phố D" },
];
const districtOption = [
  { value: "district", label: "Quận A" },
  { value: "district", label: "Quận B" },
  { value: "district", label: "Quận C" },
  { value: "district", label: "Quận D" },
];
const wardOption = [
  { value: "ward", label: "Phường A" },
  { value: "ward", label: "Phường B" },
  { value: "ward", label: "Phường C" },
  { value: "ward", label: "Phường D" },
];
function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    bankName,
    taxId,
    address,
    city,
    district,
    ward,
    sentDate,
    sendingPeriod,
    sendingTimes,
    bankId,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={bankName.name}
            label={bankName.label}
            value={values.bankName}
            error={errors.bankName && touched.bankName}
            success={values.bankName?.toString().length > 0 && !errors.bankName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={address.name}
            label={address.label}
            value={values.address}
            error={errors.address && touched.address}
            success={values.address?.toString().length > 0 && !errors.address}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={cityOption}
            type={city.type}
            label={city.label}
            name={city.name}
            value={values.city}
            placeholder={city.placeholder}
            error={errors.city && touched.city}
            success={values.city.length > 0 && !errors.city}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOption}
            type={district.type}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={ward.name}
            label={ward.label}
            value={values.ward}
            error={errors.ward && touched.ward}
            success={values.ward?.toString().length > 0 && !errors.ward}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "d-m-Y",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "d/m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={sentDate.name}
            label={sentDate.label}
            error={errors.sentDate && touched.sentDate}
            success={values.sentDate?.toString().length > 0 && !errors.sentDate}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={sendingPeriod.name}
            label={sendingPeriod.label}
            value={values.sendingPeriod}
            error={errors.sendingPeriod && touched.sendingPeriod}
            success={values.sendingPeriod?.toString().length > 0 && !errors.sendingPeriod}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={sendingTimes.name}
            label={sendingTimes.label}
            value={values.sendingTimes}
            error={errors.sendingTimes && touched.sendingTimes}
            success={values.sendingTimes?.toString().length > 0 && !errors.sendingTimes}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            name={bankId.name}
            label={bankId.label}
            value={values.bankId}
            error={errors.bankId && touched.bankId}
            success={values.bankId?.toString().length > 0 && !errors.bankId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            Ngân hàng cung cấp danh sách số hiệu tài khoản thanh toán của khách hàng là người nộp
            thuế, cụ thể như sau:
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
